import { render, staticRenderFns } from "./page-shell.vue?vue&type=template&id=bcebb0aa&"
import script from "./page-shell.vue?vue&type=script&lang=js&"
export * from "./page-shell.vue?vue&type=script&lang=js&"
import style0 from "./page-shell.vue?vue&type=style&index=0&id=bcebb0aa&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports